if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /* UpdateParticipant
        *
        * Update
        *
        * expects:
        * <someelement data-interaction="RequestInsuranceCertificate" data-lookup-url="url_of_lookup_webservice">
        *
        * */
        ZZ.RequestInsuranceCertificate = function(
            requestInsuranceCertificateContainer
        ) {
            var base = this;
            base.container = requestInsuranceCertificateContainer;

            base.url = base.container.attr("data-request-url");

            base.submitBtn = base.container.find("a");

            base.config = {
                invalidClassName: "error",
                validClassName: "accord"
            };

            base.assignListeners();
        };

        ZZ.RequestInsuranceCertificate.prototype = {
            assignListeners: function() {
                var base = this;

                base.submitBtn.on("click", this.update.bind(this));
            },

            update: function(event) {
                event.preventDefault();
                var base = this;
                var parameters;

                base.container.addClass("loading");

                $.ajax({
                    url: base.url,
                    dataType: "json",
                    redirLogout: true /* redirect in case logged out (redirect-proxy.js) */,
                    success: function(response) {
                        //response kan update met waarde ok of fieldname met fieldmessage bevattten of message met waarde
                        if (response.message === undefined) {
                            base.showMessage(response.update, response.message);
                        } else if (response.update !== undefined) {
                            if (
                                typeof response.update === "string" &&
                                response.update.toUpperCase() === "ACCORD"
                            ) {
                                base.showMessage(
                                    response.update,
                                    response.message,
                                    response.buttontext
                                );
                            }
                            if (
                                typeof response.update === "string" &&
                                response.update.toUpperCase() === "ERROR"
                            ) {
                                base.showMessage(
                                    response.update,
                                    response.message
                                );
                            }
                        }
                        base.container.removeClass("loading");
                    },
                    error: function() {
                        base.container.removeClass("loading");
                    }
                });
            },

            showMessage: function(cssClass, message, buttontext) {
                var base = this;
                var html =
                    '<div class="highlight ' +
                    cssClass +
                    '">' +
                    "<p><strong>" +
                    message.title +
                    "</strong>" +
                    "<br>" +
                    message.text +
                    "</p>" +
                    "</div>";

                base.container
                    .parent()
                    .find(".highlight")
                    .remove();
                base.container.parent().prepend(html);

                if (buttontext !== undefined) {
                    base.submitBtn.replaceWith(buttontext);
                }
            }
        };
    })(jQuery);
}
